export default __webpack_public_path__ + "assets/images/467608bbe82f408e4db061037660149a.png";